<template>
    <div class="solution-summary pb-2">
        <b-card no-body v-if="personal_loan_draft_products.length > 0">
            <b-card-header header-bg-variant="primary" header-class="p-2 text-white">
                Personal Loan
            </b-card-header>
            <b-card-body class="px-4 py-2">
                <b-row class="mb-3 pt-2" v-for="(product, index) in personal_loan_draft_products" :key="index">
                    <b-col cols="12" md="3" class="border-right d-flex align-items-center">
                        <div>
                            <el-image
                                    class="rounded mr-2"
                                    :src="product.product_banks[0].prod_bnk_logo_url"
                                    fit="cover"
                                    style="height: 25px;"
                                ></el-image>
                        </div>
                    </b-col>
                    <b-col cols="12" md="9">
                        <b-row>
                            <b-col cols="12" md="4" v-if="checkAppCode('sas')">
                                <b-form-group label="Arrangement Fee (RM)">
                                    <b-form-input
                                        v-model="product.product_banks[0].prod_bnk_agreement_rate"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Loan Amount">
                                    <b-form-input
                                        v-model="product.product_banks[0].prod_bnk_loan_amount"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Interest Rate">
                                    <b-form-input
                                        v-model="product.product_banks[0].prod_bnk_interest"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Tenure">
                                    <b-form-input
                                        v-model="product.product_banks[0].prod_bnk_tenure"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4">
                                <b-form-group label="Installment">
                                    <b-form-input
                                        v-model="product.product_banks[0].prod_bnk_installment"
                                        type="text"
                                        required
                                        disabled
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="mx-auto mt-1 pb-1">
                        <b-row>
                            <b-col cols="12">
                                <div class="d-flex justify-content-end align-items-center">
                                    <div>
                                        <el-button class="bg-success py-2 text-white" 
                                          @click="convertProductToCaseHandler(product.prod_id)" 
                                          :loading="is_loading.case && is_loading.value === product.prod_id"
                                        ><small class="font-weight-bold text-white">CONVERT TO CASE</small>
                                        </el-button>
                                          <el-button class="bg-danger py-2 text-white" 
                                          @click="removeProductHandler(product)"
                                          :loading="is_loading.case && is_loading.value === product.prod_id"
                                        ><small class="font-weight-bold text-white">REMOVE</small>
                                        </el-button>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <div class="text-center mt-5" v-else>No draft found.</div>
    </div>
</template>
<script>
import { Image, Button } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'

export default {
    components: {
        CurrencyInput,
        [Image.name]: Image,
        [Button.name]: Button,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            is_loading: {
                case: false,
                value: ''
            },
        }
    },
    computed:{
        ...mapState(useProductStore, ['personal_loan_draft_products']),
    },
    methods:{
        ...mapActions(useProductStore, ['removeProduct', 'convertProductToCase']),
        ...mapActions(useNotificationStore, ['fetchEmailTemplate']),
        ...mapActions(useMessagingStore, ['sendEmail']),
        resetIsLoading(){
            this.is_loading.case = false
            this.is_loading.value = null
        },
        async convertProductToCaseHandler(id){
            this.is_loading.case = true
            this.is_loading.value = id
            try{
                await this.convertProductToCase(id, 'personal_loan')
                await this.sendCaseApprovalEmail(id)
                this.resetIsLoading()
                if(this.checkAppCode('sas')){
                    this.notifySuccess('<b>Case Successfully Created </b> - Pending Approval.')
                }else{
                    this.notifySuccess('<b>Case Successfully Created </b>')
                }
            }catch(e){
                this.errorFunction(e)
                this.resetIsLoading()
                return
            }
        },
        async sendCaseApprovalEmail(id) {
          try{
            const emailTemplate = await this.fetchEmailTemplate('CREATE_CASE_APPROVAL');
            if (emailTemplate && emailTemplate.is_active == 1) {

            const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

            // Prepare the email data
            const emailData = {
                to: recipients,
                subject: emailTemplate.notif_temp_title,
                body: emailTemplate.notif_temp_message
                    .replace('{case_id}', id) // Replace {case_id} with product ID
            };

            await this.sendEmail(emailData);
              this.notifySuccess('Email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        async removeProductHandler(product){
            try{
                await this.removeProduct(product)
                this.notifySuccess('<b>Draft </b> - Successfully Removed.')
                
            }catch(e){
                this.errorFunction(null, e)
            }
        }
    }
}
</script>